import { InjectionToken } from '@angular/core';
import { IbCPermanentUserService } from 'ib-web-commons/app/core/utils/ib-commons-permanent-user-service';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsIbCPermanentUserService = new InjectionToken('IbCPermanentUserService');
export const AJSGiftCardsIbCPermanentUserServiceProvider = upgradeAJSServiceProvider('IbCPermanentUserService', AJSGiftCardsIbCPermanentUserService);
export interface GiftCardsIbCPermanentUserServiceType extends IbCPermanentUserService {
    isAfterLoginPermanentUser()
    checkPermanentUserFlow()
}
